import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PolicyListService } from '../service/policy-list.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import {ModalsObservationComponent} from './modals-observation/modals-observation.component'
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-policy-list',
  templateUrl: './policy-list.component.html',
  styleUrls: ['./policy-list.component.css'],
})
export class PolicyListComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  pageSizeOptions: any [] = [5, 10, 20];
  pageSize = 10;
  pageNumber = 1;

  totalPage: any [] = [];
  SeeAllPolicies: any[] = [];
  totalItems: number;
  typesSelect: any;
  statusSelect: any;
  //-----------Filters
  requestF: string;
  typeF: string;
  statusF: string;
  order: string;
  baseReq: string;
  //-----------------asc&desc state---------------------
  requestDesc = false;
  typeDesc = false;
  statusDesc = false;

  constructor(private dataApi: PolicyListService,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,) {

    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.order = "&order_by=requestNumber&desc=true";
    this.baseReq= this.order;

  }

  getPolicyList() {
    this.spinner.show("loading");
    this.dataApi.getPolicyList(this.pageNumber, this.pageSize, this.baseReq)
      .subscribe((data: any) => {
        this.SeeAllPolicies = data.items;
        this.typesSelect= data.types;
        this.statusSelect= data.statuses;
        this.pageNumber = data.paginator.page;
        this.pageSize = data.paginator.limit;
        this.totalPage = data.paginator.totalPages;
        this.totalItems = data.paginator.totalItems;

        for (var h = 0; h < this.SeeAllPolicies.length ; h++){​​
          let typeEsNames = this.concatTypes(this.SeeAllPolicies[h].typePolicy, 'es');
          let typeEnNames = this.concatTypes(this.SeeAllPolicies[h].typePolicy, 'en');
          Object.assign(this.SeeAllPolicies[h], {​​ typeEsNames,typeEnNames}​​)
         }​​


        this.spinner.hide("loading");
      }, (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      });
  }
  concatTypes(types, languaje){​​
    let TypesConcat=undefined;
    if(languaje=='es'){​​
      for (let type of types){​​
        if (TypesConcat === undefined){​​
          TypesConcat = type.NameEs;
        }​​else {​​
          TypesConcat = TypesConcat+ ", \n" + type.NameEs
          }​​
      }​​
    }​​
    if(languaje=='en'){​​
      for(let type of types){​​
        if (TypesConcat=== undefined){​​
          TypesConcat = type.Name;
        }​​else {​​
          TypesConcat = TypesConcat+ ", \n" + type.Name
        }​​
      }​​
     }​​
     return TypesConcat;

  }​​
  openDialogObs(dataReq) {
    this.spinner.show("loading");
    this.dataApi.getObservacion(dataReq.policyId).subscribe((data: any) => {
      let observations;
      if (data){
        observations = data;
      } else {
        observations = [];
      }
      this.spinner.hide("loading");
      this.dialog.open(ModalsObservationComponent, {panelClass: 'myapp-no-padding-dialog', data: observations });
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

  ngOnInit() {
    this.getPolicyList();
  }
  getlang(){

    return sessionStorage.getItem('lang');
  }

  handlePage(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
    this.getPolicyList();
  }



  //------ method set filters ---
  orderby(nameColumn, typeAsc){
    switch(nameColumn){
      case 'requestNumber': {
        this.requestDesc = !this.requestDesc;
        this.typeDesc = false;
        this.statusDesc = false;
        break;
      }
      case 'type':{
        this.requestDesc = false;
        this.typeDesc = !this.typeDesc;
        this.statusDesc = false;
        break;
      }
      case 'status':{
        this.requestDesc = false;
        this.typeDesc = false;
        this.statusDesc = !this.statusDesc;
        break;
      }
    }
    const param = `&order_by=${nameColumn}&desc=${typeAsc}`;
    this.order = param;
    this.getallpolicyFilter();
  }
  requestFilter(){
    if(this.requestF === '' || this.requestF === null || this.requestF === undefined ){
      return '';
    } else {
      return '&policyId=' + this.requestF;
    };
  }
  TypeFilter(){
    if(this.typeF === '' || this.typeF === null || this.typeF === undefined ){
      return '';
    } else {
      return '&type='+ this.typeF;
    };
  }
  StatusFilter(){
    if(this.statusF === '' || this.statusF === null || this.statusF === undefined){
      return '';
    } else {
      return '&status=' + this.statusF;
    };
  }

  getallpolicyFilter() {
    this.baseReq=this.order + this.TypeFilter() + this.StatusFilter()+ this.requestFilter() ;
    this.applyFilter(this.baseReq);
  }

  applyFilter(filterUrl){
    this.spinner.show("loading");
    this.paginator.firstPage();
    this.dataApi.getPolicyList(this.pageNumber, this.pageSize, filterUrl)
      .subscribe((data: any) => {
        this.SeeAllPolicies = data.items;
        this.typesSelect= data.types;
        this.statusSelect= data.statuses;
        this.pageNumber = data.paginator.page;
        this.pageSize = data.paginator.limit;
        this.totalPage = data.paginator.totalPages;
        this.totalItems = data.paginator.totalItems;

        for (var h = 0; h < this.SeeAllPolicies.length ; h++){​​
          let typeEsNames = this.concatTypes(this.SeeAllPolicies[h].typePolicy, 'es');
          let typeEnNames = this.concatTypes(this.SeeAllPolicies[h].typePolicy, 'en');
          Object.assign(this.SeeAllPolicies[h], {​​ typeEsNames,typeEnNames}​​)
         }​​
        this.spinner.hide("loading");
      }, (err) => {
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      });
  }
  clearFilter(){
    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.order = "&order_by=requestNumber&desc=true";
    this.getallpolicyFilter();
  }

  isNegative(requestF:string){
    let evaluate=Number(requestF)
    if(evaluate<0) {
      return true
    }
    else {
      return false;
    }

  }
}
